import React, { Fragment } from "react";
import GetTime from "../../GetTime.js";
const DelayReport = (props) => {
  console.log("delayprops", props.delayReport[0]);
  return (
    <div className="delay_report_container px-2 py-2">
      <div className="container">
        <span className="delay_report_title">Delay Reported</span>
        {props.delayReport &&
          props.delayReport[0] &&
          props.delayReport[0].data &&
          props.delayReport[0].data.map((obj, k) => (
            <Fragment key={k}>
              {" "}
              {
                <div className="row delay_reports px-3 py-2">
                  <div className="col-8 delay_report_detail">
                    {obj.reason}
                    <div className="delay_report_timing">{obj.added_at}</div>
                  </div>
                  <div className="col-4 delay_in_timing">
                    Delay: {obj.delay_time}
                  </div>
                </div>
              }
            </Fragment>
          ))}
      </div>
    </div>
  );
};
export default DelayReport;



// WEBPACK FOOTER //
// ./src/components/Intransit/ViewTripList/DelayReport.js